import * as React from "react";
const SvgMemo = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.50033 6.66667H12.5003M7.50033 10H12.5003M7.50033 13.3333H10.0003M15.8337 6.5V13.5C15.8337 14.9001 15.8337 15.6002 15.5612 16.135C15.3215 16.6054 14.939 16.9878 14.4686 17.2275C13.9339 17.5 13.2338 17.5 11.8337 17.5H8.16699C6.76686 17.5 6.0668 17.5 5.53202 17.2275C5.06161 16.9878 4.67916 16.6054 4.43948 16.135C4.16699 15.6002 4.16699 14.9001 4.16699 13.5V6.5C4.16699 5.09987 4.16699 4.3998 4.43948 3.86502C4.67916 3.39462 5.06161 3.01217 5.53202 2.77248C6.0668 2.5 6.76686 2.5 8.16699 2.5H11.8337C13.2338 2.5 13.9339 2.5 14.4686 2.77248C14.939 3.01217 15.3215 3.39462 15.5612 3.86502C15.8337 4.3998 15.8337 5.09987 15.8337 6.5Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgMemo;
